import { Global } from '@emotion/react';

import type { CSSResetProps } from '@chakra-ui/react';

const css = String.raw;

/**
 * Apply a CSS reset specifically to the scope of the PaymentCardForm, or
 * globally if no scope (or an empty scope) is provided.
 *
 * Needed to ensure the parent application's styles don't affect PaymentCardForm.
 *
 * @prop {string} [scope] CSS selector to apply the reset to. Should select
 *                        PaymentCardForm and its child elements. If blank,
 *                        applies styles globally.
 */
export const CSSResetPT = (props: CSSResetProps) => {
  const scope = props?.scope || null;
  const maybeScope = scope ? `:where(${scope})` : '';
  return (
    <Global
      styles={css`
        ${maybeScope || ':root'} {
          --gap: 1.5rem;
          --column-gap: 1rem;
          --control-pad: 8px;
        }

        ${maybeScope} .FieldsSectionBody {
          display: flex;
          flex-wrap: wrap;
          gap: var(--gap);
          column-gap: var(--column-gap);
        }

        ${maybeScope} .FieldsSectionHeading {
          padding-top: var(--gap);
          padding-bottom: var(--gap);
        }

        ${maybeScope} .FormControlContainer {
          margin: 0px;
        }

        ${maybeScope} .LongTextControl {
          width: 100%;
        }

        ${maybeScope} .ShortTextControl {
          max-width: calc(50% - var(--control-pad));
          width: 100%;
        }

        ${maybeScope} :is(.ShortTextControl, .LongTextControl) :is(input, select) {
          width: 100%;
        }
      `}
    />
  );
};
